/**
 * Macro resolver types.
 *
 * @module macros/types
 */

/** Mutable context shared across a single workflow run for stateful macros like $SEQUENCE(). */
export interface MacroResolutionContext {
  /** Per-name counters for $SEQUENCE() — resets between runs. */
  sequenceCounters: Map<string, number>;
  /** Cached LLM resolutions for $AI(prompt), keyed by stripped prompt — populated by the AI prepass before sync resolution. */
  aiResolutions: Map<string, string>;
}

/** Record of a single macro resolution (expression → resolved value). */
export interface MacroResolution {
  /** Original macro expression, e.g. "$UUID()" */
  expression: string;
  /** Resolved output, e.g. "a1b2c3d4-..." */
  resolved: string;
}

/**
 * Maps input field names to their macro resolutions.
 * Used by cache recording to map resolved values back to expressions.
 */
export type MacroResolutionLog = Map<string, MacroResolution>;

export class MacroUnknownError extends Error {
  readonly _tag = 'MacroUnknownError';
  constructor(macroName: string) {
    super(`Unknown macro: $${macroName}()`);
    this.name = 'MacroUnknownError';
  }
}

export class MacroArgError extends Error {
  readonly _tag = 'MacroArgError';
  constructor(macroName: string, message: string) {
    super(`$${macroName}(): ${message}`);
    this.name = 'MacroArgError';
  }
}
